import { jsx as e, jsxs as p, Fragment as m } from "react/jsx-runtime";
import { clsx as d } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { RocheUIAccordion as h } from "../../accordion/roche-accordion.js";
import { RocheUIAccordionAppearance as f } from "../../accordion/roche-accordion.types.js";
import { RocheUIBadge as g } from "../../badge/roche-badge.js";
import o from "./roche-pipeline-row-group-section.module.scss.js";
const I = ({
  group: i,
  triggerLabel: n,
  rowRenderer: s,
  initiallyOpen: a = !1,
  headlineLevel: t,
  hasTightGap: l = !1
}) => /* @__PURE__ */ e(
  h,
  {
    headlineLevel: t,
    sections: [
      {
        id: i.id,
        headline: n,
        badge: /* @__PURE__ */ p(m, { children: [
          /* @__PURE__ */ e("span", { className: o["pipeline-row-group-section__badge"], "aria-hidden": "true", children: /* @__PURE__ */ e(g, { text: i.items.length }) }),
          /* @__PURE__ */ e(
            "span",
            {
              className: o["pipeline-row-group-section__visually-hidden"],
              children: `${i.items.length} items`
            }
          )
        ] })
      }
    ],
    initiallyOpen: a ? 0 : void 0,
    appearance: f.COMPACT,
    iconVariant: "chevron",
    hasMarginTop: !1,
    hasBorderBottom: !1,
    children: [
      /* @__PURE__ */ e(
        "ul",
        {
          className: d(
            o["pipeline-row-group-section__list"],
            l && o["pipeline-row-group-section__list--tight-gap"]
          ),
          children: i.items.map((c, r) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: the feed ships exact duplicate rows, so only the position is unique
            /* @__PURE__ */ e("li", { children: s(c, r) }, r)
          ))
        },
        i.id
      )
    ]
  }
);
export {
  I as RocheUIPipelineRowGroupSection
};
